import { useMutation } from "@tanstack/react-query";
import { getApp } from "firebase/app";
import { doc, getFirestore, updateDoc } from "firebase/firestore";
import dayjs from "dayjs";
import { COURSE_CLASS_COLLECTION } from "src/constants/collectionsIds";

export default function useUpdateClassSession(options) {
  return useMutation({
    mutationFn: async (vars) => {
      const { form, category, region, instructor, id } = vars;
      const app = getApp();
      const db = getFirestore(app);
      const sessionDoc = doc(db, `${COURSE_CLASS_COLLECTION}/${id}`);

      const session = {
        ...form,
      };

      const start_time = dayjs(session.start_time);
      const end_time = dayjs(session.end_time);

      const startDateTime = dayjs(session.end_date)
        .set("hours", start_time.hour())
        .set("minutes", start_time.minute());
      const endDateTime = dayjs(session.start_date)
        .set("hours", end_time.hour())
        .set("minutes", end_time.minute());

      await updateDoc(sessionDoc, {
        instructor,
        region,
        category,
        endDateTime: endDateTime.format("YYYY-MM-DD HH:mm"),
        startDateTime: startDateTime.format("YYYY-MM-DD HH:mm"),
        //
        start_time: session.start_time,
        end_time: session.end_time,
        start_date: session.start_date,
        end_date: session.end_date,
        slots: session.slots,
        courseType: category.id,
        instructorId: session?.instructor,
        regionId: session.location,
        categoryId: session.category,
        status: "pending",
        leftStudents: session.slots,
        name: session.title_en,
        name_de: session.title_de,
        part: session.part,
        weekly_day: session.weekly_day,
        duration: session.duration,
        price: session.price,
        payment: session.payment,
      });
    },
    ...options,
  });
}
